import FilesContainer from '../components/FilesContainer'

const FilesPage = () => {
  return <FilesContainer />
}

export default FilesPage
